export default __webpack_public_path__ + "static/media/t10.dd29b19b.jpg";